// Canvas work (html2canvas for the PDF, the image cropper) needs CORS-readable
// images. Capturify's S3 photos send no CORS headers, so cross-origin images are
// loaded through our same-origin proxy in server.js instead.
export const toSameOriginImageUrl = (url: string): string => {
  if (!/^https?:\/\//i.test(url)) return url; // data:, blob:, relative paths
  try {
    if (new URL(url).origin === window.location.origin) return url;
  } catch {
    return url;
  }
  return `/api/image-proxy?url=${encodeURIComponent(url)}`;
};
